import React, { Component } from 'react';
import Moment from 'react-moment';
import 'moment-timezone';
import 'moment/locale/es';
import '../../css/chat/message.css';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from "react-i18next";
import ReferencedMessage from './referencedmessage';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';

class Message extends Component {

    render() {

        let message = <div ref={this.props.childref}></div>,
            msgClass = "user-message badge-light-primary",
            timeClass = "user-time",
            nameClass = "user-name text-muted",
            date = new Date(this.props.date),
            icon = <div className={`user-icon ${this.props.channel}`} style={this.props.image != null && this.props.image.trim() !== "" ? { backgroundImage: `url(${this.props.image})` } : {}}></div>,
            dateFormat = "HH:mm",
            opts = <></>;

        if (this.props.isHistory)
            dateFormat = "DD/MM/yyyy HH:mm"

        if ((this.props.text != null && this.props.text.length > 0) || this.props.media) {

            let text = this.props.buttonText || this.props.ogText || this.props.text;

            if (this.props.interaction && this.props.interaction.aiTranslation)
                text = this.props.text || this.props.ogText;

            if (this.props.searchText && this.props.text.toLowerCase().indexOf(this.props.searchText) >= 0) {
                text = text.replace(new RegExp("<mark>", 'g'), "");
                text = text.replace(new RegExp("</mark>", 'g'), "");
                text = text.replace(new RegExp(this.props.searchText + "(?=[^]*)", "ig"), "<mark>$&</mark>");
            }

            if (this.props.type === "A") {
                let usrImgPath = `//${this.props.photo}`;

                if (this.props.isHistory)
                    usrImgPath = this.props.image;

                icon = <div className="user-img-chat"
                    style={this.props.photo != null && this.props.photo.trim() !== "" ? { backgroundImage: `url(${usrImgPath})` } : {}}
                ></div>;

                msgClass = "agent-message";
                timeClass = "agent-time";
                nameClass = "agent-name text-muted";
            };

            message = <div className={msgClass} dangerouslySetInnerHTML={{ __html: text }}></div>;
            if (this.props.media) {

                let mediaElement = null,
                    url = "";
                if (this.props.url)
                    url = !this.props.url.startsWith("http") ? `${this.props.chatUrl}/${this.props.url}` : this.props.url;

                switch (this.props.mediaType) {
                    case "image":
                        mediaElement = <img src={url} width="100%" alt={text} title={text} />;
                        break;
                    case "video":
                        mediaElement = <video src={url} width="100%" controls={true} />;
                        break;
                    case "audio":
                    case "voice":
                        mediaElement = <audio src={url} width="100%" controls={true} />;
                        break;
                    case "document":
                    case "file":
                        if (url.indexOf(".pdf") > -1) {
                            mediaElement = <embed src={url} width="100%"></embed>;
                        }
                        break;
                    case "options":
                        var textTokens = text.split("<br/>");
                        if (textTokens.length > 1) {
                            text = textTokens[0];
                        }
                        break;
                    case "contacts":
                        mediaElement = this.props.contacts.map((v, i) => {
                            return (
                                <Card>
                                    <Card.Body>
                                        <Card.Title> <FontAwesomeIcon icon={duotone('circle-user')} size='xl' /> {v.name.formatted_name}</Card.Title>
                                        <Card.Text>
                                            {
                                                v.phones.map((x, j) => {
                                                    return x.phone;
                                                })
                                            }
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            )
                        });
                        break;
                    default:

                }

                message = <div className={msgClass}>
                    <a href={url} target="_blank" rel="noopener noreferrer">{mediaElement}
                        <FontAwesomeIcon icon={duotone('file')} /> <div dangerouslySetInnerHTML={{ __html: text }}></div>
                    </a>
                </div>

                if (this.props.mediaType === "options") {
                    opts = <div className="sys-opts" dangerouslySetInnerHTML={{ __html: textTokens[1] }}></div>
                }
                if (this.props.mediaType === "contacts") {
                    message = <div className={msgClass}>{mediaElement}</div>;
                }
            }

            message = (<>
                <div className='message' ref={this.props.childref} id={this.props.id}>
                    {icon}
                    <div className={nameClass} >{this.props.senderName}</div>
                    <div className={timeClass}><Moment format={dateFormat}>{date}</Moment></div>
                    {this.props.reference &&
                        <ReferencedMessage
                            key={`ref_${this.props.reference.id}`}
                            id={`ref_${this.props.reference.id}`}
                            senderName={this.props.reference.name}
                            text={this.props.reference.text}
                            type={this.props.reference.type}
                            channel={this.props.reference.channel}
                            media={this.props.reference.media}
                            image={this.props.reference.image}
                            mediaType={this.props.reference.mediaType}
                            url={this.props.reference.url}
                            from={this.props.reference.from}
                            isHistory={this.props.reference.isHistory}
                            date={this.props.reference.date}
                        />
                    }
                    {message}
                </div>
                {opts}
            </>);
        }

        return message;

    }
}

const mapStateToProps = (state) => {
    return {
        photo: state.agent.photo,
        chatUrl: state.parameters.chatUrl,
        searchText: state.interaction.searchText,
        interaction: state.interaction.current
    };
};

export default compose(connect(mapStateToProps), withTranslation())(Message);
